// context/SharedFormContext.js
import React, { createContext, useState, useContext, useCallback } from 'react'; // 1. ADIM: useCallback'i import et

const SharedFormContext = createContext();

export const SharedFormProvider = ({ children }) => {
    const [sharedFormData, setSharedFormData] = useState({
        token: null,
        entrepreneurInfo: null,
        financialInputs: null,
        financialResults: null,
        assessmentAnswers: null,
        assessmentResults: null
    });
    
    // localStorage.removeItem('sharedFormEmail'); // Bu satırı başlangıçta çalıştırmak genellikle istenmez, bir fonksiyona bağlamak daha iyi olabilir. Şimdilik yorum satırı yapıldı.

    // 2. ADIM: Tüm fonksiyonları useCallback ile sarmala
    const updateEntrepreneurInfo = useCallback((data) => {
        setSharedFormData(prev => ({
            ...prev,
            entrepreneurInfo: data
        }));
    }, []);

    const updateSharedFinancials = useCallback((inputs, results) => {
        setSharedFormData(prev => ({
            ...prev,
            financialInputs: inputs,
            financialResults: results
        }));
    }, []);

    const updateSharedAssessment = useCallback((answers, results) => {
        setSharedFormData(prev => ({
            ...prev,
            assessmentAnswers: answers,
            assessmentResults: results
        }));
    }, []);

    const setSharedToken = useCallback((token) => {
        setSharedFormData(prev => ({
            ...prev,
            token
        }));
    }, []);

    const clearSharedFormData = useCallback(() => {
        setSharedFormData({
            token: null,
            entrepreneurInfo: null,
            financialInputs: null,
            financialResults: null,
            assessmentAnswers: null,
            assessmentResults: null
        });
    }, []);

    return (
        <SharedFormContext.Provider value={{
            sharedFormData,
            updateEntrepreneurInfo,
            updateSharedFinancials,
            updateSharedAssessment,
            setSharedToken,
            clearSharedFormData
        }}>
            {children}
        </SharedFormContext.Provider>
    );
};

export const useSharedForm = () => {
    const context = useContext(SharedFormContext);
    if (!context) {
        throw new Error('useSharedForm must be used within SharedFormProvider');
    }
    return context;
};

export { SharedFormContext };